import { render, staticRenderFns } from "./ResidentStatements.vue?vue&type=template&id=368044a5&scoped=true&"
import script from "./ResidentStatements.vue?vue&type=script&lang=ts&"
export * from "./ResidentStatements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368044a5",
  null
  
)

export default component.exports